import { render, staticRenderFns } from "./koPrimaryList.vue?vue&type=template&id=098527c3&scoped=true&name=koList&"
import script from "./koPrimaryList.vue?vue&type=script&lang=js&"
export * from "./koPrimaryList.vue?vue&type=script&lang=js&"
import style0 from "./koPrimaryList.vue?vue&type=style&index=0&id=098527c3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "098527c3",
  null
  
)

export default component.exports